import React from "react";
import { ProfileHead } from "../ProfileHead";

const Account = ({ userData }) => {
  return (
    <div>
      <ProfileHead activeItem={"account"} />

      <div className="py-4 m-2">
        <h2 className="border-b-2 text-xl font-medium font-sans capitalize mb-4">
          Loyalty
        </h2>
        <h2 className="border-b-2 text-xl font-medium font-sans capitalize mb-4">
          Payment
        </h2>
      </div>
    </div>
  );
};

export default Account;
